import {
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalCloseButton,
   ModalBody,
   Box,
   Stack,
   Flex,
   Text,
   Button,
} from '@chakra-ui/react';
import { useLocalization } from '~/framework';
import { useQuizSessionsContext } from '../QuizSessionsContext';
import { TeamSearchInput } from '~/pages/_shared/TeamSearchInput';
import { useLoggedInUser } from '~/pages/_shared';

export function TeamModal() {
   const { _js } = useLocalization();
   const { data: user } = useLoggedInUser();
   const { showTeamModal, setShowTeamModal, setTeamFilter } = useQuizSessionsContext();
   const ownerTeamUserid =
      user?.isUserAnyTeamOwner && !user?.permissions.canIViewAllQuizSessions
         ? user?.userid
         : undefined;

   return (
      <Modal isOpen={showTeamModal} onClose={() => setShowTeamModal(false)}>
         <ModalOverlay />
         <ModalContent>
            <ModalHeader>{_js('Filter by team')}</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
               <Stack>
                  <Box>
                     <Text variant="muted">
                        {_js('Select a team to filter the quiz sessions')}:
                     </Text>
                     <TeamSearchInput onChange={setTeamFilter} ownerTeamUserid={ownerTeamUserid} />
                  </Box>
               </Stack>
            </ModalBody>
            <Flex m={5} justify="space-between">
               <Button
                  color="red"
                  onClick={() => {
                     setTeamFilter(0, '');
                     setShowTeamModal(false);
                  }}
               >
                  {_js('Clear filter')}
               </Button>
            </Flex>
         </ModalContent>
      </Modal>
   );
}
